import {DatabaseCode} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Badge, BadgeProps} from "../Badge/Badge";
import {forwardRef} from "react";

export type DatabaseCodeBadgeProps = Omit<BadgeProps, 'children'> & {
  value: DatabaseCode
}

export const DatabaseCodeBadge = forwardRef<HTMLDivElement, DatabaseCodeBadgeProps>((props, ref) => {
  const {value, ...rest} = props;

  const {t} = useTranslation(["common"]);

  return (
    <Badge ref={ref} {...rest}>
      {t(value.displayValue.id, value.displayValue.defaultMessage)}
    </Badge>
  );
});
